module.exports = {"id":"200841","name":"Carl Jenkinson","rating":"72","photo":"./data/images/photos/4/200841.png","club":{"name":"Birmingham City","logo":"./data/images/clubs/BirminghamCity.png"},"positions":["DD"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/CarlJenkinson0.json
// module id = 704
// module chunks = 0